import { dateToString } from './dateToString';

/**
 * Recursively convert Date objects in an object to strings.
 * @param object - The object to process.
 */
const changeDateToStringInObject = (object: object): any =>
  Object.fromEntries(
    Object.entries(object).map(([key, value]) => {
      if (value instanceof Date) {
        return [key, dateToString(value)];
      }
      if (Array.isArray(value)) {
        return [
          key,
          value.map(item => {
            if (item instanceof Date) {
              return dateToString(item);
            }
            if (
              typeof item === 'object' &&
              item !== null &&
              item !== undefined
            ) {
              return changeDateToStringInObject(item);
            }
            return item;
          }),
        ];
      }
      if (typeof value === 'object' && value !== null) {
        return [key, changeDateToStringInObject(value)];
      }
      return [key, value];
    }),
  );

/**
 * Safely stringify an object to JSON, handling correct date formatting.
 */
export const safeJsonStringify = (data: object) => {
  /**
   * Check if the data is not an object or is null.
   */
  if (typeof data !== 'object' || data === null) {
    return JSON.stringify(data);
  }

  /**
   * Execute on transformations on the data object.
   */
  const preparedData = [changeDateToStringInObject].reduce(
    (acc, fn) => fn(acc),
    data,
  );

  return JSON.stringify(preparedData);
};
